import http from '@/api/http';

export default {
  //告警列表
  getWarningList: (opts = {}) =>
    http.get('/warning/v1/warning/list', {
      query: {
        page: opts.page,
        per_page: 15,
        catalog: 1,
      },
    }),
  //运行情况
  getPcStatus: () => http.get('/monitor/v1/guest/summary'),
  //排队情况
  getLineStatus: () => http.get('/monitor/v1/queue/summary'),
  //日常监控
  getDailyChart: (opts = {}) =>
    http.post(`/monitor/v1/pool/stats`, {
      body: {
        pool_id: opts.pool_id,
        start_date: opts.start,
        end_date: opts.end,
      },
    }),
  //机库列表
  getServerList: () =>
    http.get('/host/manage/v1/dispatch/server_list', {
      query: {
        page: 1,
        per_page: 1000,
      },
    }),
  //pool 列表
  getPoolList: (opts = {}) =>
    http.get('/host/manage/v1/pool/list', {
      query: {
        page: 1,
        per_page: 1000,
        mid: opts.mid,
      },
    }),
  //获取使用统计数据
  getUsageStat: (opts = {}) =>
    http.get('/monitor/v1/host/usage_summary', {
      query: {
        start_date: opts.startDate,
        end_date: opts.endDate,
      },
    }),
  //获取使用统计数据
  dumpHostUsage: (opts = {}) =>
    http.get('/monitor/v1/host/usage_dump', {
      query: {
        start_date: opts.startDate,
        end_date: opts.endDate,
      },
    }),
  //机器使用率
  getUsedRate: (opts = {}) =>
    http.get('/monitor/v1/host/used_rate', {
      query: {
        start_date: opts.start,
        end_date: opts.end,
        bside: opts.bside,
        pid: opts.pid,
      },
    }),
  //机房数据
  getComputerRoomData: (opts = {}) =>
    http.get('/monitor/v1/host/stats', {
      query: {
        start_date: opts.start,
        end_date: opts.end,
        bside: opts.bside,
        pid: opts.pid,
      },
    }),
  //业务数据
  getBusinessData: (opts = {}) =>
    http.get('/monitor/v1/host/used_stats_by_queue', {
      query: {
        start_date: opts.start,
        end_date: opts.end,
        bside: opts.bside,
        pid: opts.pid,
      },
    }),
  //数据详情
  getDetailData: (opts = {}) =>
    http.get('/monitor/v1/host/stats_detail', {
      query: {
        start_date: opts.start,
        end_date: opts.end,
      },
    }),
};
